export default __webpack_public_path__ + "static/main-in-browser-apps-preview-1397c25f4db3fd6be80227c2093ccb9a.png";